import axiosClient from '@/config/api/axios'
import { INTEGRATION_CONNECTIONS } from '@/config/api/endpoints'

/**
 * Ask whether a connected account actually works.
 *
 * ACTIVE only means the token is valid. A Google account with no mailbox grants
 * full Gmail scopes at consent and then refuses every Gmail call, so without
 * this the first sign of trouble was a failed send — after research, a
 * generated report and an approval.
 *
 * `checked: null` means the toolkit offers no safe probe, so nothing was
 * verified. That is not a failure and must never be shown as one.
 *
 * @param {{ connectionId: string, workspaceId?: string, signal?: AbortSignal }} options
 * @returns {Promise<{ healthy: boolean, checked: string | null, detail: string | null }>}
 */
export async function verifyConnection({ connectionId, workspaceId, signal }) {
  const { data } = await axiosClient.post(
    `${INTEGRATION_CONNECTIONS}/${connectionId}/verify`,
    undefined,
    { signal, headers: workspaceId ? { 'X-Workspace-Id': workspaceId } : undefined },
  )
  return {
    healthy: data?.healthy !== false,
    checked: data?.checked ?? null,
    detail: data?.detail ?? null,
  }
}
